import React, { useState } from "react";

import {
  AdminLayout,
  useOpenDashServices,
  useTranslation,
} from "@opendash/core";

import { DataFetchingOptionsInterface } from "@opendash/plugin-timeseries";
import { Button, Col, Divider, Row, Select } from "antd";
import download from "downloadjs";
import { MobilityInvoiceType } from "../types";

import { WidgetStatic } from "@opendash/plugin-monitoring";
import { AdminToolbar, Description, FixedIntervalPicker } from "@opendash/ui";
import Parse from "parse";
import { districtData } from "../widgets/leaflet-district-kpi";

import { Icon } from "@opendash/icons";
import dayjs from "dayjs";

export const MobilityInvoice = (props: MobilityInvoiceType) => {
  const t = useTranslation();

  const [zones, setZones] = useState([]);

  const [provider, setProvider] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState<string>(null);
  const [selectedZones, setSelectedZones] = useState<string[]>(null);
  const [prices, setPrices] = useState<any[]>(null);
  const [template, setTemplate] = useState<Parse.File | null>(null);
  const { SourceService } = useOpenDashServices();
  const [timeframe, setTimeframe] = useState<[number, number]>([
    dayjs().subtract(1, "day").toDate().getTime(),
    dayjs().toDate().getTime(),
  ]);
  const downloadReport = async () => {
    const zoneData = districtData();
    const reportZones = zoneData.map((zone) => {
      if (zone.id) {
        const cZone = zones.find((z) => z.id === zone.id);
        const cPrice = prices.find(
          (p) =>
            (p.get("zone")?.id || null) === zone.id &&
            p.get("provider").id === selectedProvider
        );

        return {
          id: zone.id,
          label: cZone.get("label"),
          count: zone.count,
          priceEach: cPrice.get("pricePerVehicle"),
          priceTotal: zone.count * cPrice.get("pricePerVehicle"),
        };
      } else {
        const cPrice = prices.find((p) => {
          return !p.zone && p.get("provider").id === selectedProvider;
        });
        return {
          id: "_other",
          label: "Sonstige Bereiche",
          count: zone.count,
          priceEach: cPrice.get("pricePerVehicle"),
          priceTotal: zone.count * cPrice.get("pricePerVehicle"),
        };
      }
    });
    const orderedZones = selectedZones.map((zoneId) => {
      return reportZones.find((z) => z.id === zoneId);
    });
    orderedZones.push(reportZones.find((z) => z.id === "_other"));
    const cProvider = provider.find((p) => p.id === selectedProvider);
    const options = {
      zones: orderedZones,
      invoiceDate: dayjs().format("DD.MM.YYYY"),
      invoicenumber: "1234",
      totals: {
        count: zoneData.reduce((a, b) => a + b.count, 0),
        price: reportZones.reduce((a, b) => a + b.priceTotal, 0),
      },
      provider: {
        label: cProvider.get("label"),
        street: cProvider.get("streetAndNumber"),
        city: cProvider.get("city"),
        postalcode: cProvider.get("postalcode"),
        state: cProvider.get("state"),
        department: cProvider.get("department"),
      },
    };
    const payload = {
      description: "KVBInvoice",
      title: "Invoice",
      masterData: {},
      options,
      template: template.url(),
      items: [],
    };
    const response = await fetch(props.reportURL, {
      method: "POST",
      headers: {
        ...props.reportHeader,
        "Content-Type": "application/json",
        "OD-SESSION": Parse.User.current().getSessionToken(),
      },
      body: JSON.stringify({ params: payload }),
    });

    const blob = await response.blob();

    download(blob, "KVB_Rechnung.docx");
  };
  const init = async () => {
    try {
      const res = await new Parse.Query("MIAAS_Geographies")
        .limit(99999)
        .find();
      setZones(res);

      const provider = await new Parse.Query("MIAAS_Provider")
        .limit(99999)
        .find();
      setProvider(provider);

      const prices = await new Parse.Query("MIAAS_Pricing")
        .limit(99999)
        .include("provider")
        .include("zone")
        .find();
      setPrices(prices);

      const ctemplate = await new Parse.Object("OWReport", {
        id: "gmTy5AqxIb",
      }).fetch();
      //@ts-ignore
      setTemplate(ctemplate.get("template") as unknown as Parse.File);
    } catch (e) {
      console.log(e);
    }
  };
  React.useEffect(() => {
    init();
  }, []);

  return (
    <AdminLayout contentPadding={true}>
      <AdminToolbar title="Rechnung erstellen" />
      <div className="od-page-main">
        <Row>
          <Col span={2} style={{ textAlign: "center" }}>
            <Icon icon="fa:car" style={{ fontSize: "4em", color: "#666767" }} />
          </Col>
          <Col span={21} offset={1}>
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="Anbieter"
              defaultValue={selectedProvider}
              onChange={(selection) => {
                const [source, ,] = provider
                  .find((p) => p.id === selection)
                  .get("allVehicles");
                if (source !== SourceService.getCurrent().tag) {
                  SourceService.setCurrent(
                    SourceService.getAll().find((s) => s.tag === source).id
                  );
                }
                setSelectedProvider(selection);
              }}
              options={provider.map((provider) => {
                return { label: provider.get("label"), value: provider.id };
              })}
            />
            <Description>Fahrzeuge bzw. Hersteller auswählen</Description>
          </Col>
          <Divider />
        </Row>

        <Row>
          <Col span={2} style={{ textAlign: "center" }}>
            <Icon icon="fa:map" style={{ fontSize: "4em", color: "#666767" }} />
          </Col>
          <Col span={21} offset={1}>
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              placeholder="Zonen auswählen"
              defaultValue={[]}
              onChange={(selection) => {
                setSelectedZones(selection as string[]);
              }}
              options={zones.map((zone) => {
                return { label: zone.get("label"), value: zone.id };
              })}
            />
            <Description>Zonen auswählen</Description>
          </Col>
          <Divider />
        </Row>
        <Row>
          <Col span={2} style={{ textAlign: "center" }}>
            <Icon
              icon="fa:clock"
              style={{ fontSize: "4em", color: "#666767" }}
            />
          </Col>
          <Col span={21} offset={1}>
            <FixedIntervalPicker
              value={timeframe}
              onChange={(timeframe, mode) => {
                setTimeframe(timeframe);
              }}
            />

            <Description>Zeitraum auswählen</Description>
          </Col>
        </Row>

        {timeframe[0] < timeframe[1] &&
          selectedProvider &&
          selectedZones &&
          zones.length > 0 && (
            <>
              <Divider> Vorschau </Divider>
              <Row>
                <Col span={24}>
                  <Button
                    type="primary"
                    style={{ width: "100%", marginBottom: 16 }}
                    onClick={() => {
                      downloadReport();
                    }}
                  >
                    Rechnung herunterladen
                  </Button>
                </Col>
              </Row>
              <Row style={{ height: 150 * selectedZones.length }}>
                <Col
                  span={24}
                  style={{
                    height: 150 * selectedZones.length,
                    overflow: "hidden",
                  }}
                >
                  <WidgetStatic
                    config={{
                      _history: {
                        historyType: "absolute",
                        start: timeframe[0],
                        end: timeframe[1],
                      } as DataFetchingOptionsInterface,
                      _dimensions: [
                        provider
                          .find((p) => p.id === selectedProvider)
                          .get("allVehicles"),
                      ],
                      type: "zones",
                      districtsFromZones: selectedZones,
                    }}
                    type="opendash-widget-leaflet-district-kpi"
                  />
                </Col>
              </Row>
            </>
          )}
      </div>
    </AdminLayout>
  );
};
export default MobilityInvoice;
